import React from 'react'
import PropTypes from 'prop-types'

const TopBottomToggleOption = ({ value, label, selected, changeHandler }) => (
  <span className="top-bottom__option cmwf--radio-option">
    <input
      className="top-bottom__option__input"
      type="radio"
      id={`cmwf--${value}`}
      checked={selected}
      onChange={() => changeHandler(value)}
    />
    <label className="top-bottom__option__label" htmlFor={`cmwf--${value}`}>{label}</label>
  </span>
)

TopBottomToggleOption.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  changeHandler: PropTypes.func.isRequired,
}

export default TopBottomToggleOption



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/top-bottom-toggle-option.jsx